import React from 'react';
export default function getHeaderLinks(){

    return (
        <>
            <button className="userButton" onClick={
                ()=>{
                    let a = document.createElement("A");
                    a.href = process.env.REACT_APP_MDM_URL;
                    a.target="_blank";
                    a.click();
                }
            }>
            <i class="fa fa-link" aria-hidden="true" title="Go to MDM"></i>
            </button>
        </>
    )
}
